import React from 'react'

// import {InlineIcon} from '@iconify/react'
// import asterisk from '@iconify/icons-mdi/asterisk'

// import Tooltip from '../admin/common/MyTooltip'

const MandatoryField = ({title}) => (

  <div
  //  style={{
  //   display: 'flex',
  //   flexDirection: 'row',
  //   alignItems: 'center',
    // margin: 0,
  // }}
  >
    <span style={{
      color: '#d60404',
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      marginRight: '2px',
      // marginTop: '0px',
      // marginBottom: '0px',
      // // marginTop: '8px',
      // fontSize: '18px',
      // // backgroundColor: 'blue',
      // height: '100%',
      // alignSelf: 'center',
      // cursor: 'pointer'
    }}>
      *
    </span>
    {title}
    </div>
)

export default MandatoryField
